import { createSlice } from "@reduxjs/toolkit";

const resolveBrowserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Amman";
  } catch {
    return "Asia/Amman";
  }
};

const initialState = {
  // Keep a concrete value so store resets do not leave the dashboard
  // rendering UTC values until the app mounts again.
  timeZone: resolveBrowserTimeZone(),
};

const timeZoneSlice = createSlice({
  name: "timezone",
  initialState,
  reducers: {
    setTimeZone: (state, action) => {
      state.timeZone = action.payload || resolveBrowserTimeZone();
    },
  },
});

export const { setTimeZone } = timeZoneSlice.actions;

export default timeZoneSlice.reducer;
